import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// GS We expect this global to be defined on the page and contain the cirrent local setting & translations
declare var KCDR_ALL_TRANSLATIONS: any;

// Fallback for KCDR_ALL_TRANSLATIONS if not defined
const translations = (typeof KCDR_ALL_TRANSLATIONS !== 'undefined') ? KCDR_ALL_TRANSLATIONS : {
  locale: 'en',
  translations: {}
};

i18n
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: translations.locale,
    fallbackLng: translations.locale,
    debug: true,
    initImmediate: true,

    resources: translations.translations,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;




